<template>
  <div class="form-group">
    <slot v-bind="{ attributes }" />

    <UiErrorMessagesInput v-if="hasErrors" :errors="activeErrorMessages" />

    <UiErrorMessagesInput v-if="serverErrors" :errors="serverErrors" />
  </div>
</template>

<script>
import { singleErrorExtractorMixin } from 'vuelidate-error-extractor'
import UiErrorMessagesInput from '@/components/errors/UiErrorMessagesInput.vue'

export default {
  components: { UiErrorMessagesInput },
  mixins: [singleErrorExtractorMixin],
  props: {
    serverErrors: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasAnyErrors() {
      return this.hasErrors || this.hasServerError
    },
    hasServerError() {
      return !!this.serverErrors.length
    },
    isFullyValid() {
      return this.isValid && !this.hasServerError
    },
    attributes() {
      return {
        class: {
          'is-valid': this.isFullyValid,
          'is-invalid-input': this.hasAnyErrors,
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.form-group {
  &:not(:last-child) {
    margin-bottom: rem(16px);
  }
}
</style>
